import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const token = this.getToken();

      const isFormData = request.body instanceof FormData;

  if (token) {
    // Clone the request with Authorization header
    // Only set Content-Type if it's NOT FormData
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' })
      }
    });
  } else {
            console.warn('No token found, request will be sent without authorization header.');
        }

        return next.handle(request).pipe(
            // Optionally, you can add error handling here
            catchError((error: HttpErrorResponse) => {
                // Handle the error
                if (error.status === 401 || error.status === 403) {
                    // Handle unauthorized or forbidden errors
                    console.error('Unauthorized request:', error);
                    // Optionally, you can redirect to login or show a message
                    // For example, you can use a service to handle session expiration
                    // this.sessionService.handleSessionExpiration();
                    // Redirect to login or show a message
                    this.router.navigate(['/auth/login']);
                    // or you can use a snackbar service to show a message
                    // this.snackBarService.error('Session expired. Please login again.');
                    console.warn('Session expired or unauthorized access. Please login again.');
                    // You can redirect to login or show a message here
                } else {
                    console.error('HTTP error:', error);
                }
                return throwError(() => error);
            })
        );
    }

    private getToken(): string {
        const tokenData = localStorage.getItem('isLoggedIn');
        if (tokenData) {
            try {
                const parsedData = JSON.parse(tokenData);
                return parsedData.data?.token || '';
            } catch {
                return '';
            }
        }
        return '';
    }
} 